import React from "react";
import Modal from "react-bootstrap/Modal";
//import Moment from 'react-moment';
//import 'moment-timezone';
import { dirname, basename } from "../../utils/commonUtilities";
import {
  getUserTimeZone,
  userGroupUrlCheck,
} from "../../utils/userGroupUrlCheck";
import { converDateToLocal } from "../../utils/commonUtilities";
import { checkPermissions } from "../../utils/permissions";
import AWS from "aws-sdk";
import {
  AWS_ACCESS_KEY_ID,
  AWS_SECRET_ACCESS_KEY,
  AWS_STORAGE_BUCKET_NAME,
  AWS_STORAGE_PDF_FOLDER,
} from "../../configs/awsConfigs";
import {
  LBL_EVENT_PREFIX,
  LBL_SHIFT_PREFIX,
  LBL_QUOTE,
  LBL_CLIENT,
  LBL_PO,
  LBL_CREW,
  LBL_CREWS,
  LBL_CHIEF,
  LBL_CHIEFS,
  LBL_AFFILIATE,
  LBL_CREW_CHIEF,
  LBL_TIME_ZONE,
  LBL_ISSUE_DATE,
  LBL_MODIFIED_DATE,
  LBL_QUOTE_VALID_UNTIL,
  LBL_REQUEST,
  LBL_ACCEPT,
  LBL_REJECT,
  LBL_SEND_TO,
  LBL_TOTAL,
  LBL_HOURS_SHORT,
  LBL_SUB_TOTAL,
  LBL_VAT,
  LBL_BANK_ACC_DET,
  LBL_CONTACT,
  LBL_DISCOUNT,
} from "../../configs/labelConfigs";

import {
  EVENT_STATUS_CANCELLED,
  SHIFT_STATUS_CANCELLED,
} from "../../configs/staticConfigs";

import {
  showSendQuoteBtn,
  showRequestQuoteBtn,
  showAcceptRejectQuoteBtn,
  showAcceptRejectQuoteBtnAflt,
} from "./eventStatusCheck";
import { convertDecimalToHHMM } from "../../utils/commonUtilities";
import CustomModalHeaderStepper from "./customModalHeaderStepper";

class PreviewQuote extends React.Component {
  constructor(props) {
    super();
    this.state = {
      showModal: false,
      quotePDFName: "",
    };
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleModelClose = this.handleModelClose.bind(this);
    this.sendQuoteToClient = this.sendQuoteToClient.bind(this);
  }

  requestQuoteBtnClick = (eventId) => {
    this.props.requestQuoteBtnClick(eventId);
  };

  // changeModalHeight = () =>{
  //       setTimeout(()=> {
  //           if(document.getElementsByClassName("modal-dialog")[0]!=undefined){
  //           document.getElementsByClassName("modal-dialog")[0].style.height = "99%";
  //           }
  //       }, 5);
  //   }

  handleOpenModal = () => {
    this.setState({
      showModal: true,
    });
    // this.changeModalHeight();
  };

  handleModelClose = () => {
    this.setState(
      {
        showModal: false,
      },
      () => {
        this.props.resetModalForm();
      }
    );
  };

  sendQuoteToClient = (eventId) => {
    this.props.sendQuoteToClient(eventId);
  };

  acceptQuote = (eventId) => {
    this.props.acceptQuote(eventId);
  };

  acceptQuoteWithPO = (eventId, poNumber) => {
    this.props.acceptQuoteWithPO(eventId, poNumber);
  };

  rejectQuote = (eventId) => {
    this.props.rejectQuote(eventId);
  };

  downloadQuote = (eventId) => {
    this.props.downloadQuote(eventId);
  };

  downloadQuotePDFBKUP = () => {
    // let pdfURL = 'https://s3-bankend.s3.amazonaws.com/static/quote/quote-10-115-1000-2020-06-11_094744.117767.pdf';
    // let pdfURL = '../../assets/quote-10-115-1000-2020-06-11_094744.117767.pdf';
    if (
      this.props.hasOwnProperty("quoteDownloadFileName") &&
      this.props.quoteDownloadFileName
    ) {
      let pdfURL = this.props.quoteDownloadFileName;
      let folderPath = dirname(pdfURL);
      let pdfName = basename(pdfURL);
      fetch(folderPath).then((response) => {
        response.blob().then((blob) => {
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement("a");
          a.href = url;
          a.download = pdfName;
          a.click();
        });
        //window.location.href = response.url;
      });
    } else {
      //console.log('Download File Not Available');
    }
  };

  downloadQuotePDF = () => {
    var s3 = new AWS.S3({
      accessKeyId: AWS_ACCESS_KEY_ID,
      secretAccessKey: AWS_SECRET_ACCESS_KEY,
      region: "ap-south-1",
    });
    let pdfURL =
      AWS_STORAGE_PDF_FOLDER + "quote-10-115-1000-2020-06-11_094744.117767.pdf";
    s3.getObject(
      { Bucket: AWS_STORAGE_BUCKET_NAME, Key: pdfURL },
      function (error, data) {
        if (error != null) {
          alert("Failed to retrieve an object: " + error);
        } else {
          alert("Loaded " + data.ContentLength + " bytes");
          // do something with data.Body
        }
      }
    );
  };

  downloadQuotePDF222 = () => {
    let pdfURL =
      "https://s3-bankend.s3.amazonaws.com/static/quote/quote-10-115-1000-2020-06-11_094744.117767.pdf";
    let folderPath = dirname(pdfURL);
    let pdfName = basename(pdfURL);
    fetch(folderPath).then((response) => {
      response.blob().then((blob) => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = pdfName;
        a.click();
      });
      //window.location.href = response.url;
    });
  };

  render() {
    const { eventPreviewQuote, isClientPage } = this.props;
    const userCurrency = this.props.profileCurrency;

    let eventId = "";
    let poNumber = "";
    let quoteNumber = "";
    let affCompanyName = "";
    let affCompanyPhone = "";
    let affCompanyWebsite = "";
    let affCompanyEmail = "";
    let affCompanyLogo = "";
    let affLocation = "";
    let affAdditionalText = "";
    let requestedBy = "";

    let affDynamicFields = [];
    let clientName = "";
    let clientContact = "";
    let clientVenue = "";
    let clientStreetOne = "";
    let clientStreetTwo = "";
    let clientCity = "";
    let clientState = "";
    let clientCountry = "";
    let clientPostcode = "";
    let clientPhone = "";
    let eventTitle = "";
    let eventNumber = "";
    let eventLocationId = 0;
    let eventLocation = "";
    let eventStartDTime = "";
    let eventEndDTime = "";
    let eventReqCrews = 0;
    let eventReqChiefs = 0;
    let eventCancelled = "";
    // let eventVenue = '';
    // let eventStreetOne = '';
    // let eventStreetTwo = '';
    // let eventCity = '';
    // let eventState= '';
    // let eventCountry= '';
    // let eventPostcode= '';

    let shiftdata = [];
    let subTotal = "";
    let overallTotal = "";
    let discountCost = 0;
    let vatCost = "";
    let eventQuoteStatus = 0;
    let eventStatus = 0;
    let showSendQuote = false;
    let showRequestQuote = false;
    let showAcceptQuote = 0;
    let showRejectQuote = 0;
    let isAffiliateCanAcceptQuote = true; // IF PERMISSION COMES SET THIS VARIABLE ACCORDING TO IT
    let canAcceptQuote = isClientPage ? true : isAffiliateCanAcceptQuote;

    let timeZone = getUserTimeZone(window.location);

    let userGroupData = userGroupUrlCheck(window.location);
    let supervisor_name = "";
    let crew_chief = "";
    if (userGroupData !== undefined) {
      supervisor_name = userGroupData.supervisor_name;
      crew_chief = userGroupData.supervisor_name;
    }
    if (!supervisor_name) {
      supervisor_name = LBL_CHIEF;
      crew_chief = LBL_CREW_CHIEF;
    }

    let is_active = this.props.hasOwnProperty("is_active")
      ? this.props.is_active
      : true;
    let issueDate = "";
    let modifiedDate = "";
    let validUntilDate = "";
    let timeZoneName = timeZone.region;
    let isViewAcceptQuote =
      is_active === true && checkPermissions("acceptquote", "view");
    let signature = "";
    let signatureUrl = "";
    let poOrSign = false;
    if (eventPreviewQuote !== "") {
      eventId = eventPreviewQuote.id;

      if (
        eventPreviewQuote.hasOwnProperty("quote_set") &&
        Array.isArray(eventPreviewQuote.quote_set)
      ) {
        let quote_set = eventPreviewQuote.quote_set[0];
        if (quote_set.valid_until && quote_set.valid_until.trim().length > 0)
          validUntilDate = converDateToLocal(
            quote_set.valid_until,
            "00:00",
            "ddmmyyyyhhmm"
          );
        if (
          quote_set.quote_sent_datetime &&
          quote_set.quote_sent_datetime.trim().length > 0
        )
          issueDate = converDateToLocal(
            quote_set.actual_quote_sent_datetime,
            "00:00",
            "ddmmyyyyhhmm"
          );
        if (
          quote_set.quote_re_sent_datetime &&
          quote_set.quote_re_sent_datetime.trim().length > 0 &&
          quote_set.quote_sent_datetime !== quote_set.quote_re_sent_datetime
        )
          modifiedDate = converDateToLocal(
            quote_set.actual_quote_re_sent_datetime,
            "00:00",
            "ddmmyyyyhhmm"
          );
      }

      poNumber =
        eventPreviewQuote.po_number === null ? "" : eventPreviewQuote.po_number;
      signatureUrl =
        eventPreviewQuote.signature === null ? "" : eventPreviewQuote.signature;

      if (poNumber.length > 0) {
        poOrSign = true;
      }

      if (signatureUrl.length > 0) {
        poOrSign = true;
      }

      quoteNumber = eventPreviewQuote.quote_number;
      let affDynamicFieldsFilter = [];
      if (eventPreviewQuote.affiliate_profile) {
        affCompanyName = eventPreviewQuote.affiliate_profile.company_name;
        affCompanyPhone = eventPreviewQuote.affiliate_profile.phone_number;
        affCompanyWebsite = eventPreviewQuote.affiliate_profile.web_site;
        affCompanyEmail = eventPreviewQuote.affiliate_profile.company_email;
        affCompanyLogo = eventPreviewQuote.affiliate_profile.logo;
        if (eventPreviewQuote.affiliate_profile.location !== null) {
          affLocation = eventPreviewQuote.affiliate_profile.location.location;
          affDynamicFieldsFilter =
            eventPreviewQuote.affiliate_profile.dynamic_fields.filter(
              (x) => x !== null
            );
        }
        if (eventPreviewQuote.affiliate_profile.additional_text !== null) {
          affAdditionalText =
            eventPreviewQuote.affiliate_profile.additional_text;
        }
      }

      requestedBy = eventPreviewQuote.requested_by;

      if (affDynamicFieldsFilter.length > 0) {
        affDynamicFieldsFilter[0].field_details.forEach((item) => {
          if (item.value && item.value.trim()) affDynamicFields.push(item);
        });
      }

      let clientUsers = [];
      if (eventPreviewQuote.client_profile) {
        if (
          eventPreviewQuote.client_contact &&
          eventPreviewQuote.client_contact.length > 0
        ) {
          clientContact = eventPreviewQuote.client_contact;
        } else {
          clientUsers =
            eventPreviewQuote.client_profile.associateusers_set.filter(
              (x) => x !== null
            );
          if (clientUsers.length > 0) {
            clientContact =
              clientUsers[0].user.first_name +
              " " +
              clientUsers[0].user.last_name;
          }
        }

        clientName = eventPreviewQuote.client_profile.company_name;
        // clientPhone = eventPreviewQuote.client_profile.phone_number
        clientPhone = eventPreviewQuote.client_phone_number;
        if (eventPreviewQuote.client_profile.location !== null) {
          clientVenue = eventPreviewQuote.client_profile.location.venue
            ? eventPreviewQuote.client_profile.location.venue
            : "";
          clientStreetOne = eventPreviewQuote.client_profile.location.street1
            ? eventPreviewQuote.client_profile.location.street1
            : "";
          clientStreetTwo = eventPreviewQuote.client_profile.location.street2
            ? eventPreviewQuote.client_profile.location.street2
            : "";
          clientCity = eventPreviewQuote.client_profile.location.city
            ? eventPreviewQuote.client_profile.location.city
            : "";
          clientState = eventPreviewQuote.client_profile.location.state
            ? eventPreviewQuote.client_profile.location.state
            : "";
          clientCountry = eventPreviewQuote.client_profile.location.country
            ? eventPreviewQuote.client_profile.location.country
            : "";
          clientPostcode = eventPreviewQuote.client_profile.location.postcode
            ? eventPreviewQuote.client_profile.location.postcode
            : "";
        }
      }

      eventTitle = eventPreviewQuote.title;
      eventCancelled =
        Number(eventPreviewQuote.status) === Number(EVENT_STATUS_CANCELLED)
          ? " (Cancelled)"
          : "";

      eventNumber =
        eventPreviewQuote.event_number === null
          ? ""
          : eventPreviewQuote.event_number;
      let filteredShift = [];
      if (eventPreviewQuote.shift_set) {
        filteredShift = eventPreviewQuote.shift_set.filter(
          (data) => data != null
        );
      }

      if (eventPreviewQuote.location) {
        eventLocationId = eventPreviewQuote.location.location.id;
        eventLocation = eventPreviewQuote.location.location.location;
      }

      // eventStartDTime     = eventPreviewQuote.start_date;
      // eventEndDTime       = eventPreviewQuote.end_date;
      eventStartDTime = converDateToLocal(
        eventPreviewQuote.start_date,
        "+00:00",
        "ddmmyyyy"
      );
      eventEndDTime = converDateToLocal(
        eventPreviewQuote.end_date,
        "+00:00",
        "ddmmyyyy"
      );
      eventReqCrews = eventPreviewQuote.required_crews;
      eventReqChiefs = eventPreviewQuote.required_chiefs;

      shiftdata = filteredShift;
      let shiftCount = shiftdata.length;

      subTotal = eventPreviewQuote.total_cost;
      overallTotal = eventPreviewQuote.total;
      discountCost = eventPreviewQuote.discount_cost;
      vatCost = eventPreviewQuote.vat_cost;
      eventStatus = eventPreviewQuote.status;

      if (Number(eventStatus) === Number(EVENT_STATUS_CANCELLED)) {
        subTotal = "0.00";
        overallTotal = "0.00";
        discountCost = "0.00";
        vatCost = "0.00";
      }

      if (
        eventPreviewQuote.quote_set &&
        eventPreviewQuote.quote_set.length > 0
      ) {
        eventQuoteStatus = eventPreviewQuote.quote_set[0].quote_status;
        showSendQuote =
          is_active === true &&
          showSendQuoteBtn(
            isClientPage,
            eventQuoteStatus,
            quoteNumber,
            shiftCount,
            eventStatus
          );

        // FOR AFFILIATES ONLY, QUOTE CAN BE ACCEPTED IN STATUS - QUOTE_SENT, ESTIMATION & REESTIMATION - 30SEP2020
        if (!isClientPage)
          showAcceptQuote = showAcceptRejectQuoteBtnAflt(
            canAcceptQuote,
            eventStatus,
            eventQuoteStatus
          );
        else
          showAcceptQuote =
            is_active === true &&
            showAcceptRejectQuoteBtn(
              canAcceptQuote,
              eventStatus,
              eventQuoteStatus
            );

        showRejectQuote =
          is_active === true &&
          showAcceptRejectQuoteBtn(isClientPage, eventStatus, eventQuoteStatus);
        showRequestQuote =
          is_active === true &&
          showRequestQuoteBtn(isClientPage, eventStatus, eventQuoteStatus);
        signature = eventPreviewQuote.quote_set[0].signature_url;
      }
    }
    return (
      <Modal
        show={this.state.showModal}
        id={this.props.modalId}
        className="custom-modal zIndex-99999"
      >
        <Modal.Header
          closeButton={false}
          className="preview-quote zIndex-99999"
        >
          <CustomModalHeaderStepper activeStep={3} />
        </Modal.Header>
        <Modal.Body className="preview-quote">
          <div className="row ">
            <div className="col-11 p-0">
              {/* <img alt="company-logo" src={affCompanyLogo} className={affCompanyLogo===null?'hide':'img-fliud'} /> */}
              <h2 className="crew">{affCompanyName}</h2>
            </div>
            {/* <div className="col-6">
              <h2 className="quote-no">
                <span className="textNoBold">{LBL_QUOTE} No : </span>
                {quoteNumber}
              </h2>
            </div> */}
          </div>

          <div className="row">
            <div className="col-12  p-0">
              <table class="preview-quote-table">
                <thead>
                  <tr>
                    <th>Client Information</th>
                    <th>User Information</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div className="d-flex justify-content-between mb-2 pr-3">
                        <strong>Company Name</strong>
                        <div className="text-left " style={{ width: "226px" }}>
                          {clientName}
                        </div>
                      </div>
                      <div className="d-flex justify-content-between mb-2 pr-3">
                        <strong>Address</strong>
                        <div className="text-left " style={{ width: "226px" }}>
                          {[
                            clientVenue,
                            clientStreetOne,
                            clientStreetTwo,
                            clientCity,
                            clientState,
                            clientCountry,
                            clientPostcode,
                          ]
                            .filter((value) => value && value.trim().length > 0) // Filter out empty or null values
                            .join(" ") // Join all values with a space
                            .trim() && ( // Ensure there's content before rendering
                            <>
                              {[
                                clientVenue,
                                clientStreetOne,
                                clientStreetTwo,
                                clientCity,
                                clientState,
                                clientCountry,
                                clientPostcode,
                              ]
                                .filter(
                                  (value) => value && value.trim().length > 0
                                )
                                .join(" ")}
                            </>
                          )}
                        </div>
                      </div>
                      <div className="d-flex justify-content-between mb-2 pr-3">
                        <strong>Phone Number</strong>
                        <div className="text-left " style={{ width: "226px" }}>
                          {clientPhone}
                        </div>
                      </div>
                      <div className="d-flex justify-content-between mb-2 pr-3">
                        <strong>Requested by</strong>
                        <div className="text-left " style={{ width: "226px" }}>
                          {requestedBy}
                        </div>
                      </div>
                      <div className="d-flex justify-content-between  pr-3">
                        <strong>Contact</strong>
                        <div className="text-left " style={{ width: "226px" }}>
                          {clientContact}
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="d-flex justify-content-between mb-2 pr-3">
                        <strong>Company Name</strong>
                        <div className="text-left " style={{ width: "226px" }}>
                          {clientName}
                        </div>
                      </div>
                      <div className="d-flex justify-content-between mb-2 pr-3">
                        <strong>Address</strong>
                        <div className="text-left " style={{ width: "226px" }}>
                          {[
                            clientVenue,
                            clientStreetOne,
                            clientStreetTwo,
                            clientCity,
                            clientState,
                            clientCountry,
                            clientPostcode,
                          ]
                            .filter((value) => value && value.trim().length > 0) // Filter out empty or null values
                            .join(" ") // Join all values with a space
                            .trim() && ( // Ensure there's content before rendering
                            <>
                              {[
                                clientVenue,
                                clientStreetOne,
                                clientStreetTwo,
                                clientCity,
                                clientState,
                                clientCountry,
                                clientPostcode,
                              ]
                                .filter(
                                  (value) => value && value.trim().length > 0
                                )
                                .join(" ")}
                            </>
                          )}
                        </div>
                      </div>
                      <div className="d-flex justify-content-between mb-2 pr-3">
                        <strong>Phone Number</strong>
                        <div className="text-left " style={{ width: "226px" }}>
                          {clientPhone}
                        </div>
                      </div>
                      <div className="d-flex justify-content-between mb-2 pr-3">
                        <strong>Requested by</strong>
                        <div className="text-left " style={{ width: "226px" }}>
                          {requestedBy}
                        </div>
                      </div>
                      <div className="d-flex justify-content-between  pr-3">
                        <strong>Contact</strong>
                        <div className="text-left " style={{ width: "226px" }}>
                          {clientContact}
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="row">
            <div className="col-12  p-0 mt-5">
              <table class="preview-quote-table">
                <thead>
                  <tr>
                    <th colspan="3">Project Details </th>
                    <th colspan="2"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colSpan={"5"}>
                      <div className="d-flex justify-content-between mb-4 ">
                        <div
                          className="d-flex flex-column"
                          style={{ width: "226px" }}
                        >
                          <strong>Company Name</strong>
                          <div>
                            <span >{eventTitle}</span>{" "}
                            &nbsp; {LBL_EVENT_PREFIX + "" + eventNumber}{" "}
                            <span >{eventCancelled}</span>
                          </div>
                        </div>
                        <div className="d-flex">
                          <div className="d-flex flex-column pr-5">
                            <strong>Start Date & Time</strong>
                            {eventStartDTime}
                          </div>
                          <div className="d-flex flex-column pr-5">
                            <strong>End Date & Time</strong>
                            {eventEndDTime}
                          </div>
                          <div className="d-flex flex-column pr-5">
                            <strong>Shift Length</strong>
                            {eventEndDTime}
                          </div>
                        </div>
                      </div>

                      <div
                        className="d-flex flex-column"
                        style={{ width: "226px" }}
                      >
                        <strong>Venue & Address</strong>
                        {eventLocation}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="row  border-One">
            <div className="col-6">
              <p>To,</p>
              <p>&emsp; {clientName} </p>
              {clientVenue && clientVenue.trim().length > 0 && (
                <p>&emsp; {clientVenue}</p>
              )}
              {clientStreetOne && clientStreetOne.trim().length > 0 && (
                <p>&emsp; {clientStreetOne}</p>
              )}
              {clientStreetTwo && clientStreetTwo.trim().length > 0 && (
                <p>&emsp; {clientStreetTwo}</p>
              )}
              {clientCity && clientCity.trim().length > 0 && (
                <p>&emsp; {clientCity}</p>
              )}
              {clientState && clientState.trim().length > 0 && (
                <p>&emsp; {clientState}</p>
              )}
              {clientCountry && clientCountry.trim().length > 0 && (
                <p>&emsp; {clientCountry}</p>
              )}
              {clientPostcode && clientPostcode.trim().length > 0 && (
                <p>&emsp; {clientPostcode}</p>
              )}
              {clientPhone && clientPhone.trim().length > 0 && (
                <>
                  <p>&nbsp;</p>
                  <p>
                    &emsp; Tel :{" "}
                    <span className="text-bold">{clientPhone}</span>
                  </p>
                </>
              )}
            </div>
            <div className="col-6 text-right ">
              <p>&nbsp;</p>
              {/* {(issueDate) && issueDate.trim().length > 0 && <p> Issue Date : <span className="text-bold"><Moment format="DD/MM/YYYY">{new Date(issueDate)}</Moment></span></p>}  
                    {(validUntilDate) && validUntilDate.trim().length > 0 && <p> {LBL_QUOTE} Valid Until : <span className="text-bold"> <Moment format="DD/MM/YYYY">{new Date(validUntilDate)}</Moment></span></p>}  */}

              {issueDate && issueDate.trim().length > 0 && (
                <p>
                  {" "}
                  {LBL_ISSUE_DATE}:{" "}
                  <span className="text-bold">{issueDate}</span>
                </p>
              )}
              {modifiedDate && modifiedDate.trim().length > 0 && (
                <p>
                  {" "}
                  {LBL_MODIFIED_DATE}:{" "}
                  <span className="text-bold">{modifiedDate}</span>
                </p>
              )}
              {validUntilDate && validUntilDate.trim().length > 0 && (
                <p>
                  {" "}
                  {LBL_QUOTE_VALID_UNTIL}:{" "}
                  <span className="text-bold"> {validUntilDate}</span>
                </p>
              )}
              {issueDate &&
                issueDate.trim().length > 0 &&
                timeZoneName &&
                timeZoneName.trim().length > 0 && (
                  <p>
                    <small>
                      {" "}
                      {LBL_TIME_ZONE}:{" "}
                      <span className="text-bold">{timeZoneName}</span>
                    </small>
                  </p>
                )}
              {poNumber && String(poNumber).trim().length > 0 && (
                <p>
                  {" "}
                  {LBL_PO}: <span className="text-bold"> {poNumber}</span>
                </p>
              )}

              {issueDate && issueDate.trim().length > 0 && <p>&nbsp;</p>}
              {requestedBy && requestedBy.trim().length > 0 && (
                <p>
                  {" "}
                  Requested by:{" "}
                  <span className="text-bold"> {requestedBy}</span>
                </p>
              )}
              {clientContact && clientContact.trim().length > 0 && (
                <p>
                  {" "}
                  {LBL_CLIENT} Contact:{" "}
                  <span className="text-bold"> {clientContact}</span>
                </p>
              )}
            </div>
          </div>

          <div className="row preview-quote mt-10 border-OneGrey">
            <div className="col-12">
              <p className="line-height-15">
                <div className="line-height-15">
                  <span className="text-bold">{eventTitle}</span> &nbsp;{" "}
                  {LBL_EVENT_PREFIX + "" + eventNumber}{" "}
                  <span className="text-bold">{eventCancelled}</span>
                  <br></br>
                  <small>{eventLocation}</small>
                </div>
              </p>
              {/* <p><small>{eventLocation}</small></p> */}

              {/* {(eventStartDTime) && eventStartDTime.trim().length > 0 && <p className="paddingTop6"><Moment format="DD/MM/YYYY hh:mm">{new Date(eventStartDTime)}</Moment> - <Moment format="DD/MM/YYYY hh:mm">{new Date(eventEndDTime)}</Moment><small></small></p>}  */}
              {eventStartDTime && eventStartDTime.trim().length > 0 && (
                <p className="paddingTop6">
                  {eventStartDTime + " - " + eventEndDTime}
                </p>
              )}

              {/* {Number(eventReqCrews) > 0 && <p className="paddingTop6">{LBL_TOTAL+' '+LBL_CREWS+'/'+LBL_CHIEFS} : <span className="text-bold"> {eventReqCrews+'/'+eventReqChiefs}</span><small></small></p>}           */}
            </div>
          </div>

          {shiftdata.map((item, index) => {
            let total = item.total;
            let start_datetime = converDateToLocal(
              item.start_datetime,
              timeZone.utc_offset,
              "ddmmyyyyhhmm"
            );
            let end_datetime = converDateToLocal(
              item.end_datetime,
              timeZone.utc_offset,
              "ddmmyyyyhhmm"
            );
            let required_chiefs = Number(item.required_chiefs);
            let crew_chief_bonus = Number(item.crew_chief_bonus);
            let chief_bonus_total = Number(item.chief_bonus_total);
            if (required_chiefs > 0)
              crew_chief_bonus =
                parseFloat(chief_bonus_total) / required_chiefs;
            let shift_length = convertDecimalToHHMM(item.shift_length);
            let shiftCancelled =
              Number(item.status) === Number(SHIFT_STATUS_CANCELLED)
                ? " (Cancelled)"
                : "";

            return (
              <React.Fragment key={index}>
                <div className="row preview-quote mt-10 border-TopBottom">
                  <div className="col-6">
                    <p className="line-height-15">
                      <div className="line-height-15">
                        <span className="text-bold">{item.title}</span> &nbsp;{" "}
                        {LBL_SHIFT_PREFIX + "" + item.shift_number}{" "}
                        <span className="text-bold">{shiftCancelled}</span>
                        {Number(eventLocationId) !==
                          Number(item.shift_location.location.id) && (
                          <div className="widthPerc80">
                            <small>
                              {item.shift_location.location.location}
                            </small>
                          </div>
                        )}
                      </div>
                    </p>
                    {/* {(item.start_datetime) && item.start_datetime.trim().length > 0 && <p> <Moment format="DD/MM/YYYY hh:mm">{new Date(item.start_datetime)}</Moment> - <Moment format="DD/MM/YYYY hh:mm">{new Date(item.end_datetime)}</Moment><small></small></p>} */}
                    {start_datetime && start_datetime.trim().length > 0 && (
                      <p> {start_datetime + " - " + end_datetime}</p>
                    )}
                  </div>
                  <div className="col-6 text-right">
                    {item.affiliate_contact &&
                      item.affiliate_contact.trim().length > 0 && (
                        <p>
                          {LBL_AFFILIATE + " " + LBL_CONTACT} :{" "}
                          <span className="text-bold">
                            {" "}
                            {item.affiliate_contact}
                          </span>
                          <small></small>
                        </p>
                      )}
                    {item.client_contact &&
                      item.client_contact.trim().length > 0 && (
                        <p>
                          {LBL_CLIENT + " " + LBL_CONTACT} :{" "}
                          <span className="text-bold">
                            {" "}
                            {item.client_contact}
                          </span>
                          <small></small>
                        </p>
                      )}

                    {/* {Number(item.required_crews) > 0 && <p>{LBL_TOTAL+' '+LBL_CREWS+'/'+LBL_CHIEFS} : <span className="text-bold"> {item.required_crews+'/'+item.required_chiefs}</span><small></small></p>}   */}
                  </div>
                </div>

                <div className="row">
                  <table className="table">
                    <tbody>
                      {item.shift_skills.map((sk, i) => {
                        let skillHours = convertDecimalToHHMM(sk.hour);
                        return (
                          <tr key={i}>
                            <td className="width-40-percent text-left">
                              {sk.count + " x " + sk.skill.skill_name}
                            </td>
                            <td className="width-25-percent text-right">
                              {userCurrency +
                                " " +
                                sk.charge_rate +
                                "/" +
                                LBL_CREW}
                            </td>
                            <td className="width-15-percent text-right">
                              {skillHours + " " + LBL_HOURS_SHORT.toLowerCase()}
                            </td>
                            <td className="width-20-percent text-right">
                              {userCurrency + " " + sk.charge_rate_total}
                            </td>
                          </tr>
                        );
                      })}
                      {required_chiefs > 0 && (
                        <tr>
                          <td className="width-40-percent text-left">
                            {required_chiefs + " x " + crew_chief}
                          </td>
                          <td className="width-25-percent text-right">
                            {userCurrency +
                              " " +
                              crew_chief_bonus.toFixed(2) +
                              "/" +
                              supervisor_name}
                          </td>
                          <td className="width-15-percent text-right">
                            {shift_length + " " + LBL_HOURS_SHORT.toLowerCase()}
                          </td>
                          <td className="width-20-percent text-right">
                            {userCurrency + " " + chief_bonus_total.toFixed(2)}
                          </td>
                        </tr>
                      )}

                      {item.expenses.map((other, o) => {
                        return (
                          <tr key={o}>
                            <td className="width-40-percent text-left">
                              {other.other_expense.name}
                            </td>
                            <td className="width-25-percent text-right"></td>
                            <td className="width-15-percent text-right"></td>
                            <td className="width-20-percent text-right">
                              {userCurrency + " " + other.cost}
                            </td>
                          </tr>
                        );
                      })}
                      <tr>
                        <td
                          scope="row"
                          colSpan="3"
                          className="total pl-3 text-bold text-left"
                        >
                          <span className="text-bold">{LBL_TOTAL}:</span>
                        </td>
                        <td className="total text-right  text-bold">
                          <span className="text-bold">
                            {userCurrency + " " + total}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </React.Fragment>
            );
          })}
          <div className="row mt-20">
            <div className="col-6 text-left text-bold">
              {signature && <p className="pb-2 pr-2">For {clientName}</p>}
              {signature && (
                <img
                  alt="company-logo"
                  src={signature}
                  className="img-fliud"
                  style={{ maxHeight: "150px" }}
                />
              )}
            </div>
            <div className="col-6 text-right  text-bold">
              <p className="pb-2 pr-2">
                {LBL_SUB_TOTAL} &emsp; {userCurrency + " " + subTotal}
              </p>
              {parseFloat(discountCost) > 0 && (
                <p className="pb-2 pr-2">
                  {LBL_DISCOUNT} &emsp; &emsp;{" "}
                  {"- " + userCurrency + discountCost}
                </p>
              )}
              <p className="pb-2 pr-2">
                {LBL_VAT} &emsp; &emsp; {userCurrency + " " + vatCost}
              </p>
              <p className="pb-2 pr-2">
                <big>
                  {LBL_TOTAL} &emsp; {userCurrency + " " + overallTotal}
                </big>
              </p>
            </div>
          </div>
          <div className="row mt-20">
            <div className="col-6">
              {affDynamicFields.length > 0 && (
                <p className="text-bold">{LBL_BANK_ACC_DET}</p>
              )}
              {affDynamicFields.map((item, inx) => {
                if (item.value && item.value.trim()) {
                  return (
                    <React.Fragment key={inx}>
                      <p>
                        {item.field_name} : {item.value}
                      </p>
                    </React.Fragment>
                  );
                } else {
                  return <></>;
                }
              })}
            </div>
            <div className="col-6 text-left">
              <p>&nbsp;</p>
              <p className="pr-2">{affAdditionalText}</p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className=" row mt-20">
          {/* <div className="col-12">
                <p className=" text-center">
                    {affCompanyPhone!=='' &&
                        <><i className="las la-phone"></i> {affCompanyPhone}  &emsp; </>
                    }
                    {affCompanyWebsite!=='' &&
                        <><i className="las la-globe"></i> {affCompanyWebsite} &emsp; </>
                    }
                    {affCompanyEmail!=='' &&
                        <><i className="las la-envelope"></i> {affCompanyEmail}   </>
                    }
                </p>
               <p>{affLocation}</p>
            </div>  */}

          <button
            type="button"
            className="print-button"
            onClick={(e) => this.downloadQuote(eventId)}
          >
            <i className="las la-download"></i>
          </button>

          {showRequestQuote === true && (
            <button
              type="button"
              className="print-button client-btn"
              onClick={(e) => this.requestQuoteBtnClick(eventId)}
            >
              {LBL_REQUEST + " " + LBL_QUOTE}
            </button>
          )}

          {showSendQuote === true && (
            <button
              type="button"
              className="print-button client-btn"
              onClick={(e) => this.sendQuoteToClient(eventId)}
            >
              {LBL_SEND_TO + " " + LBL_CLIENT}
            </button>
          )}

          {showAcceptQuote === true &&
            poOrSign == false &&
            isViewAcceptQuote && (
              <button
                type="button"
                className="print-button client-btn"
                onClick={(e) => this.acceptQuote(eventId)}
              >
                {LBL_ACCEPT + " " + LBL_QUOTE}
              </button>
            )}

          {showAcceptQuote === true &&
            poOrSign == true &&
            isViewAcceptQuote && (
              <button
                type="button"
                className="print-button client-btn"
                onClick={(e) => this.acceptQuoteWithPO(eventId, poNumber)}
              >
                {LBL_ACCEPT + " " + LBL_QUOTE}
              </button>
            )}

          {showRejectQuote === true && (
            <button
              type="button"
              className="print-button client-btn reject-btn"
              onClick={(e) => this.rejectQuote(eventId)}
            >
              {LBL_REJECT + " " + LBL_QUOTE}
            </button>
          )}

          <button
            type="button"
            className="btn btn-secondary btn-cancel"
            data-dismiss="modal"
            aria-label="Close"
            onClick={this.handleModelClose}
          >
            {/* <span aria-hidden="true">&times;</span>  */}
            Cancel
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default PreviewQuote;
